import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, tap } from 'rxjs';

import { AuthHttpInterceptor } from '@tablesready/frontend-auth';

@Injectable({ providedIn: 'root' })
export class ForbiddenHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(tap({
      error: err => {
        // A 403 from a public route (signup, login) is that form's error to show, not a
        // missing permission, so leave the user on the form
        if (err.status === 403 && AuthHttpInterceptor.requiresAuth(request)) {
          this.router.navigate(['/profile/details']);
        }
      }
    }));
  }
}
